// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-stepper__header[data-v-4f036600]{box-shadow:none}.skill-description[data-v-4f036600]{font-style:normal;font-weight:300;font-size:18px;color:#333}", ""]);
// Exports
module.exports = exports;
